<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :selectedQidSmall="selectedQidSmall"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [
        {
          qid: 1,
          // title: '题目1',
          small: [
            {
              id: 1,
              title: '题目1',
              desc: [],
              durationTime: 100,
              stemContent: [
                {
                  type: 'text',
                  value: '辣椒，在中国饮食中扮演着重要的角色。特别是近数十年来，全民食辣几乎成了中国现代饮食的标志之一。为什么中国人喜欢吃辣椒呢？几位同学围绕这个问题展开了综合性学习。请你也加入他们的研究历程吧！'
                },
                {
                  type: 'text',
                  value: '针对这个问题，小明和小刚首先进行了讨论。'
                },
                {
                  type: 'img',
                  isBig: true,
                  value: require('@/assets/exam/31.png')
                }
              ],
              askList: [
                {
                  id: 1,
                  type: 2,
                  title: '（1）小刚的两次发言，表达了一个共同的观点。即中国人喜欢吃辣椒是因为：'
                },
                {
                  id: 1,
                  type: 5,
                  answerList: [],
                  value: [
                    {
                      type: 'text',
                      val: 'A.辣椒含有丰富的辣椒素',
                      clickStats: 'click_option_a#点击选项A',
                    },
                    {
                      type: 'text',
                      val: 'B.吃辣椒对身体健康很有好处',
                      clickStats: 'click_option_b#点击选项B',
                    },
                    {
                      type: 'text',
                      val: 'C.气候对身体的影响很大',
                      clickStats: 'click_option_c#点击选项C',
                    },
                    {
                      type: 'text',
                      val: 'D.中医在中国有着深远的影响',
                      clickStats: 'click_option_d#点击选项D',
                    }
                  ]
                },
                {
                  id: 1,
                  type: 2,
                  title: '（2）小明的发言中有哪些不恰当的地方？请你写在下面，并简单说明为什么。'
                },
                {
                  id: 1,
                  type: 1
                }
              ]
            }
          ]
        },
        {
          qid: 2,
          // title: '题目4',
          small: [
            {
              id: 2,
              title: '题目2',
              durationTime: 100,
              desc: ['2. 小明说“中国人喜欢吃辣椒，肯定不止一个原因，这确实是个复杂的问题。”请你分析中国人喜欢吃辣椒可能的理由，并结合相关资料内容具体说明。'],
              stemContent: [
                {
                  type: 'textArray',
                  label: '资料1',
                  value: [
                    { img: require('@/assets/exam/19-lajiao.png'), isBig: true },
                    { text: '摘编自：曹雨，《中国食辣史》，2019年，北京联合出版公司' }
                  ]
                }
              ],
              askList: [
                {
                  id: 1,
                  type: 1,
                  title: '',
                  isReview: true
                }
              ]
            },
          ]
        },
        {
          qid: 3,
          // title: '题目5',
          small: [
            {
              id: 3,
              title: '题目3',
              durationTime: 100,
              desc: ['3. 你认为中国人喜欢吃辣椒这种现象会一直持续吗？为什么？请结合资料1-3解释你的想法。'],
              stemContent: [
                // {
                //   type: 'text',
                //   value: '你认为中国人喜欢吃辣椒这种现象会一直持续吗？为什么？请结合资料1至三解释你的想法。'
                // },
                {
                  type: 'textArray',
                  label: '资料2：《全国中草药汇编》- 辣椒',
                  value: [
                    { img: require('@/assets/exam/25.png'), isBig: true },
                  ]
                },
                {
                  type: 'textArray',
                  label: '资料3：辣椒传入中国前，四川人吃什么？',
                  value: [
                    {
                      type: 'video',
                      value: [
                        {
                          isControl: true,
                          autoPlay: false,
                          isloop: false,
                          url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/54_63071fb5c6bdb/84831ef906471ba905ce70abb21746ac.mp4'
                        }
                      ]
                    }
                  ]
                },
                // {
                //   type: 'text',
                //   value: '<b>资料1：《全国中草药汇编》- 辣根</b>'
                // },
                // {
                //   type: 'img',
                //   value: require('@/assets/exam/25.png')
                // },
                // {
                //   type: 'text',
                //   value: '<b>资料2：辣椒传入中国前，四川人吃什么？</b>'
                // },
                // {
                //   type: 'video',
                //   autoPlay: false,
                //   value: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/54_63071fb5c6bdb/84831ef906471ba905ce70abb21746ac.mp4'
                // },
              ],
              showAnswer: false,
              askList: [
                {
                  id: 1,
                  type: 1
                }
              ]
            },
          ]
        },
        {
          qid: 4,
          // title: '题目6',
          small: [
            {
              id: 4,
              title: '题目4',
              durationTime: 100,
              desc: ['4. 你觉得他的论述有哪些优点，还有哪些不足。'],
              stemContent: [
                {
                  type: 'text',
                  value: '经过一段时间的探究，小明写下了他对“中国人喜欢吃辣椒这种现象会一直持续吗”这个问题的思考。 '
                },
                {
                  type: 'textArray',
                  label: '小明的思考',
                  value: [
                    // { text: '都江堰主要工程变化大事年表' },
                    { text: '中国人喜欢吃辣椒这种现象一定会持续的。虽然现代生活条件好了，人们有了更多可选择的调味品，但食辣早已成了中国人的饮食传统。并且，辣椒也是中医中不可或缺的一味药材。既能药用，又可食用，怎能不持续呢？我在课外阅读中还读到过，人类大脑深处总是在不断寻求新的刺激，饮食也不例外。当然，辣椒也有缺点，也要注意适量食用。' }
                  ]
                },
              ],
              askList: [
                {
                  id: 1,
                  type: 1,
                  title: ''
                }
              ]
            }
          ]
        },
        {
          qid: 5,
          // title: '题目6',
          small: [
            {
              id: 5,
              title: '题目5',
              durationTime: 100,
              desc: ['5. 看到同学们的研究，小刚也想研究“中国人为什么喜欢喝茶”这个问题。他列出了要研究的四个角度。他的研究中有哪些值得保留，还有哪些需要修改？请你借鉴辣椒研究，为他重新拟定研究角度。'],
              stemContent: [
                {
                  type: 'img',
                  value: require('@/assets/exam/teatext.png')
                }
              ],
              askList: [
                {
                  id: 1,
                  type: 1,
                  theme: 'book',
                  bookTitle: '中国人为什么喜欢喝茶',
                }
              ]
            }
          ]
        }
      ],
      isEnd: false,
      loading: false,
      answerText: '',
      selectedQidSmall: 1
    }
  },
  methods: {
    async next(sonData, currentQSmall, type) {
      const data = Object.assign({
        exam_id: 1,
        exam_num: '1_' + currentQSmall,
        subject_id: 9,
        subject_name: '食辣的原因',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 5) {
        this.selectedQidSmall = 5
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'criticismSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
